import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=a8627f48&scoped=true"
import script from "./ContractList.vue?vue&type=script&lang=ts"
export * from "./ContractList.vue?vue&type=script&lang=ts"
import style0 from "./ContractList.vue?vue&type=style&index=0&id=a8627f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8627f48",
  null
  
)

export default component.exports